import {
  withTranslation,
} from 'react-i18next';

import AdminAccessTokenFieldsView from './AdminAccessTokenFieldsView';

const TranslatedComponent = withTranslation()(AdminAccessTokenFieldsView);

const Component = TranslatedComponent;

export default Component;
